import { render, staticRenderFns } from "./SoaProductCheckRow.vue?vue&type=template&id=55dd287c&lang=pug"
import script from "./SoaProductCheckRow.vue?vue&type=script&lang=js"
export * from "./SoaProductCheckRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports